import { ReactElement, Fragment } from 'react';
import { Button, Stack } from '@mui/material';
import { AddRounded } from '@mui/icons-material';
import { Customer } from '@/core/entities';

export const ALL_ROLES = 'All roles';
export const ALL_SITES = 'All sites';

export interface CustomerUsersTableHeaderProps {
	setUserForm?: () => void;
	customer?: Customer | null;
	exportUsers?: () => void;
}

const CustomerUsersTableHeader = ({
	setUserForm,
}: CustomerUsersTableHeaderProps): ReactElement => {
	return (
		<Fragment>
			<Stack direction="row" spacing={2}>
				{setUserForm && (
					<Button variant="contained" startIcon={<AddRounded />} size="large" onClick={setUserForm}>
						Create user
					</Button>
				)}
			</Stack>
		</Fragment>
	);
};

export default CustomerUsersTableHeader;
